var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#020000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{stroke:#020000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.0194 128)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 118,
    ry: 118
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.4,100.5c0-5.8,4.7-10.4,10.4-10.4c5.8,0,10.4,4.7,10.4,10.4c0,5.8-4.7,10.4-10.4,10.4 C69.1,111,64.4,106.3,64.4,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.8,100.5c0-5.8,4.7-10.4,10.4-10.4c5.8,0,10.4,4.7,10.4,10.4c0,5.8-4.7,10.4-10.4,10.4 C175.4,111,170.8,106.3,170.8,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,198.7c-31.1,0-58.3-20-67.5-49.7c-0.4-1.3-0.2-2.7,0.6-3.8c0.8-1.1,2.1-1.7,3.4-1.7c0,0,0,0,0,0l126.9,0 c1.4,0,2.6,0.6,3.4,1.7c0.8,1.1,1,2.5,0.6,3.8C186.3,178.7,159.1,198.7,128,198.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcited);
export default __webpack_public_path__ + "static/media/Excited.0da4ee7eb4f5db29604bb879a2b9116d.svg";
export { ForwardRef as ReactComponent };